/**
 * Isolado em módulo próprio para os testes poderem simular produção
 * (`vi.mock('./env')`): no Vitest `import.meta.env.DEV` é sempre true,
 * o que deixaria o provider permanentemente no-op dentro da suíte.
 */
export function isDevEnvironment(): boolean {
  try {
    return Boolean(import.meta.env?.DEV);
  } catch {
    return false;
  }
}
